import { Config } from '../../config'

export const dsiConfig: Config = {
  partner: 'dsi',
  catalog: 'partner',
  displayName: 'Dunlap Sunbrand',
  accentColor: '#81d742',
  host: 'dsi.ecomseating.com',
}
